<template>
  <div id="loading-customer-spinner" />
</template>

<script>
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-vue-popups'
import { mapGetters } from 'vuex'

export default {
  name: 'LoadingCustomerSpinner',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      loadingCustomerStatus: 'getLoadingCustomerStatus'
    })
  },
  watch: {
    loadingCustomerStatus (status) {
      if (status) {
        showSpinner(document.getElementById('loading-customer-spinner'))
      } else {
        hideSpinner(document.getElementById('loading-customer-spinner'))
      }
    }
  },
  mounted () {
    createSpinner({
      // Specify the target for the spinner to show
      target: document.getElementById('loading-customer-spinner')
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
